module.exports = __webpack_public_path__ + "img/logo.e228a067.png";